export default function formatNumbersRatioByPercent(first: number, second: number): string {
    if (second === 0) {
        return '0%';
    }

    const res = first / second;

    if (isNaN(res)) {
        return '0%';
    }

    return `${Math.round(res * 100)}%`;
}
